import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import "./styled.css";

const questions = [
  {
    option: "a) Apenas em Dev",
    correct: false,
  },
  {
    option: "b) Apenas em Ops",
    correct: false,
  },
  {
    option: "c) DevOps (design, desenvolvimento e entrega)",
    correct: true,
  },
  {
    option:
      "d) A solução de SAI ES é um estágio novo. Ele não é aplicável em nenhuma prática pré-existente",
    correct: false,
  },
  {
    option: "e) NDA",
    correct: false,
  },
];

export default function Question35(props) {
  const { t } = useContext(QuizContext);
  const { setQuestionSelected, checkAnswers } = props;
  const [optionSelected, setOptionSelected] = useState("");

  function selectOption(option) {
    setOptionSelected(option.option);

    setQuestionSelected((state) => {
      return {
        ...state,
        question35: {
          title:
            "Em quais estágios e disciplinas do Enterprise Service o SAI ES é aplicável?",
          option: option.option,
          correct: option.correct,
          order: 35
        },
      };
    });
  }
  return (
    <div style={{ marginTop: 30 }}>
      <h5 style={{ textAlign: "center" }}>
        {t(
          "Em quais estágios e disciplinas do Enterprise Service o SAI ES é aplicável?"
        )}
      </h5>

      <div className="div-options-question-ste">
        {questions.map((e, i) => (
          <a
            key={i}
            className={`option-question-ste ${
              optionSelected === e.option && "selected-option-question-ste"
            } ${checkAnswers && (e.correct ? "check-true" : "check-false")}`}
            onClick={() => {
              if (!checkAnswers) {
                selectOption(e);
              }
            }}
          >
            {t(e.option)}
          </a>
        ))}
      </div>
    </div>
  );
}
